<template>
    <div>
      <!-- page-wrapper Start-->
      <div class="container-fluid p-0">
        <div class="row m-0">
          <div class="col-12 p-0">
            <div class="login-card">
              <div>
                <div>
                  <a class="logo">
                    <img :src="ImageEndpoint + CompanyLogo" class="img-fluid for-light" v-if="CompanyLogo" style='height: 50px;'>
                        <img src="@/assets/images/logo.png" class="img-fluid for-light" v-if="!CompanyLogo" style='height: 50px;'>
                   <!--- <img
                      src="@/assets/images/logo.png"
                      class="img-fluid for-light"
                      style="height: 50px"
                    />-->
                  </a>
                </div>
                <div class="login-main">
                  <b-card no-body>
                    <b-tabs pills vertical>
                      <b-tab active>
                        <b-card-text>
                          <form class="theme-form">
                            <h4>Retrieve your password</h4>
                            <p>Enter your email to retrieve password</p>
                            <div class="form-group">
                              <label class="col-form-label">Email Address</label>
                              <input
                                v-model="email"
                                class="form-control"
                                type="email"
                                required=""
                                :class="{
                                  'is-invalid': submitted && !email,
                                }"
                              />
                              <div
                                v-show="submitted && !email"
                                class="invalid-feedback"
                              >
                                Email is required
                              </div>
                            </div>
                            <div class="form-group mb-10">
                                <span class="f-right">
                                    <router-link to="/auth/login">
                                        <span>Login</span>
                                    </router-link>
                                </span>
                            </div>
                            <div class="form-group mb-0" style="position: static;">
                              <button
                                class="btn btn-primary btn-block"
                                type="button"
                                @click="ForgotPassword"
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </div>
                <div class="col-sm-12 text-center" v-if="CompanyLogo">
                  <p class="m-b-5">Powered by</p>
                  <img
                    src="@/assets/images/logo.png"
                    class="img-fluid for-light1"
                    style="width: 100px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- latest jquery-->
    </div>
  </template>
  
  <script>
    import firebase from "firebase";
    import Userauth from "../auth/js/index";
    import Endpoints from "@/config/ApiEndpoints.js";
    import Swal from "sweetalert2";
  
    export default {
      name: "login",
      data() {
        return {
          CompanyLogo: "",
          ImageEndpoint: Endpoints.Helper.Image + "/",
          type: "password",
          email: "",
          password: "",
          username: "",
          is_remember: "",
          passwordjwt: "",
          submitted: false,
        };
      },
      computed: {
        // JWT authentication
        loggingIn() {
          return this.$store.state.authentication.status.loggingIn;
        },
      },
      created() {
        // reset login status for JWT
        this.$store.dispatch("authentication/logout");
      },
      mounted() {
        var Company = JSON.parse(localStorage.getItem("Company"));
        if (Company && Company.logo) {
          this.CompanyLogo = Company.logo;
        }
        if(localStorage.getItem('rememberData')){
          var remeber = JSON.parse(localStorage.getItem('rememberData'));
          this.email = remeber.email;
          this.is_remember = true;
        }
      },
      methods: {
        ForgotPassword: function () {
          this.submitted = true;
          if (this.email != "") {
            var obj = { email: this.email };
            Swal.fire({
              title: "Checking...",
              text: "Please wait...",
              imageUrl: require("../assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            axios
              .post(Endpoints.User.Password.Reset, obj)
              .then((Response) => {
                Swal.close();
                if (Response.data.success === true) {
                    this.$toasted.show(Response.data.message, {
                    theme: "bubble",
                    position: "top-center",
                    type: "success",
                    duration: 2000,
                  });
                } else {
                  this.$toasted.show(Response.data.message, {
                    theme: "bubble",
                    position: "top-center",
                    type: "error",
                    duration: 2000,
                  });
                }
              })
              .catch((error) => {
                this.$toasted.show(error, {
                  theme: "bubble",
                  position: "top-center",
                  type: "error",
                  duration: 2000,
                });
              });
          } else {
            this.$toasted.show("Please enter email", {
              theme: "bubble",
              position: "top-center",
              type: "error",
              duration: 2000,
            });
          }
        },
      },
    };
  </script>
  